(() => {
  // Both product templates use the same responsive preload and gesture handling.
  const initProductGallery = (gallery, kind) => {
    if (!gallery || gallery.dataset.galleryReady) return;
    const mainImage = gallery.querySelector(kind === 'model' ? '.model-product__main-image, [data-model-gallery-main]' : '.m27-gallery__main-image, [data-m27-gallery-main]');
    const hero = gallery.querySelector(kind === 'model' ? '.model-product__hero' : '.m27-gallery__stage');
    const thumbs = [...gallery.querySelectorAll('[data-' + kind + '-gallery-thumb]')];
    const dots = kind === 'm27' ? [...gallery.querySelectorAll('[data-m27-gallery-dot]')] : [];
    const controls = dots.length ? dots : thumbs;
    const counter = gallery.querySelector('[data-' + kind + '-gallery-counter]');
    if (!mainImage || !hero || !controls.length) return;
    gallery.dataset.galleryReady = 'true';
    let activeIndex = 0;
    const preloaded = new Map();
    let preloadScheduled = false;
    const sizes = mainImage.getAttribute('sizes') || '(min-width: 1288px) 680px, (min-width: 990px) 55vw, (min-width: 761px) calc(100vw - 48px), calc(100vw - 28px)';

    const setResponsiveSource = (image, source) => {
      if (!source) return;
      image.sizes = sizes;
      try {
        const url = new URL(source, window.location.href);
        if (url.pathname.includes('/cdn/shop/')) {
          const maxWidth = Number(url.searchParams.get('width')) || 1600;
          const widths = [360, 540, 750, 960, 1200, 1400, 1600].filter(width => width <= maxWidth);
          if (!widths.includes(maxWidth)) widths.push(maxWidth);
          image.srcset = widths.sort((a, b) => a - b).map(width => {
            const sizedUrl = new URL(url.href);
            sizedUrl.searchParams.set('width', String(width));
            return sizedUrl.href + ' ' + width + 'w';
          }).join(', ');
        } else {
          image.removeAttribute('srcset');
        }
      } catch {
        image.removeAttribute('srcset');
      }
      image.src = source;
    };

    const preloadNeighbors = () => {
      preloadScheduled = false;
      // Do not compete with the first image or download the whole gallery.
      if (!mainImage.complete || !mainImage.naturalWidth) return;
      for (let offset = 1; offset <= Math.min(2, controls.length - 1); offset += 1) {
        const control = controls[(activeIndex + offset) % controls.length];
        const source = control.dataset.src;
        if (!source || preloaded.has(source)) continue;
        const cachedImage = new Image();
        cachedImage.fetchPriority = offset === 1 ? 'high' : 'low';
        cachedImage.decoding = 'async';
        preloaded.set(source, cachedImage);
        setResponsiveSource(cachedImage, source);
        cachedImage.decode?.().catch(() => {});
      }
    };
    const schedulePreload = () => {
      if (preloadScheduled || !mainImage.complete || !mainImage.naturalWidth) return;
      preloadScheduled = true;
      if (window.requestIdleCallback) window.requestIdleCallback(preloadNeighbors, {timeout: 600});
      else window.setTimeout(preloadNeighbors, 0);
    };
    const selectImage = index => {
      const control = controls[index];
      if (!control || index === activeIndex) return;
      activeIndex = index;
      setResponsiveSource(mainImage, control.dataset.src);
      mainImage.alt = control.dataset.alt || '';
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index);
        thumb.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });
      if (counter) counter.textContent = (index + 1) + ' / ' + controls.length;
      schedulePreload();
    };
    mainImage.draggable = false;
    mainImage.addEventListener('load', schedulePreload);
    dots.forEach((dot, index) => dot.addEventListener('click', () => selectImage(index)));
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => selectImage(index)));
    gallery.querySelector('[data-' + kind + '-gallery-prev]')?.addEventListener('click', () => selectImage((activeIndex + controls.length - 1) % controls.length));
    gallery.querySelector('[data-' + kind + '-gallery-next]')?.addEventListener('click', () => selectImage((activeIndex + 1) % controls.length));

    hero.style.touchAction = 'pan-y pinch-zoom';
    let gesture = null;
    const finishGesture = (x, y) => {
      const start = gesture;
      gesture = null;
      if (!start || controls.length < 2) return false;
      const dx = x - start.x;
      const dy = y - start.y;
      if (Math.abs(dx) < 24 || Math.abs(dx) < Math.abs(dy) * 1.2) return false;
      selectImage((activeIndex + (dx < 0 ? 1 : controls.length - 1)) % controls.length);
      return true;
    };
    if (window.PointerEvent) {
      hero.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.button !== 0 || event.target.closest('button, a')) {
          gesture = null;
          return;
        }
        gesture = {id: event.pointerId, x: event.clientX, y: event.clientY};
        hero.setPointerCapture?.(event.pointerId);
      });
      hero.addEventListener('pointerup', event => {
        if (!gesture || gesture.id !== event.pointerId) return;
        if (finishGesture(event.clientX, event.clientY)) event.preventDefault();
        if (hero.hasPointerCapture?.(event.pointerId)) hero.releasePointerCapture(event.pointerId);
      });
      hero.addEventListener('pointercancel', () => { gesture = null; });
      hero.addEventListener('lostpointercapture', () => { gesture = null; });
    } else {
      hero.addEventListener('touchstart', event => {
        const touch = event.touches.length === 1 ? event.touches[0] : null;
        gesture = touch ? {x: touch.clientX, y: touch.clientY} : null;
      }, {passive: true});
      hero.addEventListener('touchend', event => {
        if (event.changedTouches.length !== 1) { gesture = null; return; }
        const touch = event.changedTouches[0];
        finishGesture(touch.clientX, touch.clientY);
      }, {passive: true});
      hero.addEventListener('touchcancel', () => { gesture = null; }, {passive: true});
    }
    schedulePreload();
  };
  initProductGallery(document.querySelector('[data-m27-gallery]'), 'm27');
  initProductGallery(document.querySelector('[data-model-product]'), 'model');


})();
